import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromContainerActivity from '../_reducers/containerActivity';

export const selectContainerActivityState =
  createFeatureSelector<fromContainerActivity.ContainerActivityState>('containerActivities');

export const selectAllContainerActivities = createSelector(
  selectContainerActivityState,
  fromContainerActivity.selectAll
);

export const selectContainerActivityEntities = createSelector(
  selectContainerActivityState,
  fromContainerActivity.selectEntities
);

export const selectContainerActivityById = (id: number) =>
  createSelector(selectContainerActivityEntities, (entities) => entities[id]);

export const selectContainerActivityTotal = createSelector(
  selectContainerActivityState,
  fromContainerActivity.selectTotal
);
